import { useSelector, useDispatch } from 'react-redux';
import { setLanguage } from '../store/LanguageSlice';
import { useTranslation } from 'react-i18next';

export const useLanguage = () => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const languageState = useSelector((state) => state.language);
  
  const switchLanguage = async (newLanguage) => {
    await i18n.changeLanguage(newLanguage);
    dispatch(setLanguage(newLanguage));
  };
  
  return {
    currentLanguage: languageState.current,
    direction: languageState.direction,
    supportedLanguages: languageState.supported,
    switchLanguage
  };
};